import { FC } from 'react';

import { useWorkspaceAdmin } from '@/features/workspaces/hooks/useWorkspace';
import { Audience } from '@/models/audiences';
import { DistributionChannel } from '@/models/distributionChannels';
import { AudieneDestinationDisconnectButton } from '../../AudienceDestinationDisconnectButton';

type AudienceDestinationDisconnectColumnProps = {
  audience: Audience;
  destination: DistributionChannel;
};

export const AudienceDestinationDisconnectColumn: FC<AudienceDestinationDisconnectColumnProps> = ({ audience, destination }) => {
  const isWorkspaceAdmin = useWorkspaceAdmin();

  return (
    isWorkspaceAdmin && (
      <div className='flex items-center gap-1.5'>
        <AudieneDestinationDisconnectButton audience={audience} destination={destination} />
      </div>
    )
  );
};
